"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Size = void 0;
/** @jsx jsx */
var react_1 = __importDefault(require("react"));
var react_2 = require("@emotion/react");
var colors_1 = require("../../style/colors");
var constants_1 = require("./constants");
Object.defineProperty(exports, "Size", { enumerable: true, get: function () { return constants_1.Size; } });
var Icons = __importStar(require("react-icons/md"));
var Icon = react_1.default.memo(function (_a) {
    var _b;
    var type = _a.type, _c = _a.size, size = _c === void 0 ? 'medium' : _c, color = _a.color, props = __rest(_a, ["type", "size", "color"]);
    // If user puts wrong icon type then this will work as error handler
    var RenderedIcon = Icons.MdWarningAmber;
    if (Icons[type]) {
        RenderedIcon = Icons[type];
    }
    var style = react_2.css({
        display: 'inline-flex',
        color: color || colors_1.SixsenseColor.Gray.DEFAULT,
        fontSize: (_b = constants_1.sizeMap[size]) === null || _b === void 0 ? void 0 : _b.fontSize,
    });
    return (react_2.jsx("div", __assign({ css: style }, props),
        react_2.jsx(RenderedIcon, null)));
});
exports.default = Icon;
